import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSubscription } from "@/hooks/useSubscription";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export const PaywallModal = () => {
  const navigate = useNavigate();
  const { hasAccess, loading } = useSubscription();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!loading && !hasAccess) {
      setOpen(true);
    }
  }, [hasAccess, loading]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">Trial Ended</DialogTitle>
          <DialogDescription className="text-center">
            Your 7-day free trial has ended. Subscribe to ClassPlan to continue accessing your courses, assignments, and AI-powered study insights.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <Button onClick={() => navigate("/checkout")} className="w-full sm:w-auto">
            Subscribe from $4.17/month
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
